import EditUser from './EditUser.admin'
import EditRoles from './EditRoles.admin'
import EditPermissions from './EditPermissions.admin'

export default {
  EditUser, EditRoles, EditPermissions
}



// WEBPACK FOOTER //
// ./src/views/admin/index.js